import { createFileRoute } from "@tanstack/react-router";
import { WorkflowList } from "@/components/views/workflow/WorkflowList";

export const Route = createFileRoute("/workflows/")({
  component: WorkflowList,
});
